import { logOut } from '../../redux/actions/authActions'
import store from '../../redux/store'

export default async function handleLogout (history) {
  store.dispatch(logOut())
  history.push('/')
}
